/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import axios from 'axios';
import * as actionTypes from './actionTypes';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchGetAllCheckPayeeCode = (data) => {
  return {
    type: actionTypes.GET_CHECK_PAYEE_COMPARISION,
    checkPayeeCode: data,
  };
};

export const setLoading = (value) => ({
  type: actionTypes.IS_LOADING,
  isLoading: value,
});

export const setSearchInput = (data) => ({
  type: actionTypes.SET_SELECTED_INPUT_COMPARISION,
  payload: data,
});

export const setCheckAllocationData = (data) => ({
  type: actionTypes.SET_ALLOCATION_COMPARISION_DATA,
  payload: data,
});

export const refreshCheckAllocationComparision = () => ({
  type: actionTypes.REFRESH_CHECK_ALLOCATION_COMPARISION,
  payload: {},
});

export const setAllRebateProgram = (data) => ({
  type: actionTypes.SET_ALL_REBATE_PROGRAM_DATA,
  payload: data,
});

// API call to get check payee code
export const getCheckPayeeCode = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .get(`${serviceEndPoint.GET_CHECK_PAYEE}?codeDomainKey=CHECK_PAYEE_CD`)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchGetAllCheckPayeeCode(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchGetAllCheckPayeeCode([]));
    });
};

// This action show error message for 5 sec for no contract exists
export const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ allErrors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      allErrors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};

// API call to get Check Allocation Comparision report data
export const getCheckAllocationComparision = (values) => (dispatch) => {
  dispatch(setLoading(true));
  setCheckAllocationData([]);
  return axios
    .post(`${serviceEndPoint.GET_CHECK_ALLOCATION_COMPARISION_REPORT}`, values)
    .then((response) => {
      dispatch(setLoading(false));
      let data = response?.data?.checkAllocationComparisonReportVOlist || [];
      data = data.filter((obj) => obj.diff);
      if (data.length === 0) {
        dispatch(showNoDataMessage());
      } else {
        dispatch(setCheckAllocationData(data));
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setCheckAllocationData([]));
    });
};

export const GetAllRebateDropdown = () => async (dispatch) => {
  try {
    const response = await axios.post(serviceEndPoint.GET_ALL_DROPDN_REBATE);
    dispatch(setAllRebateProgram(response.data));
  } catch (error) {
    dispatch(setAllRebateProgram([]));
  }
};

// refresh data
export const clearReduxDataOnCheckAllocationComparisonSearchScr = () => ({
  type: actionTypes.REFRESH_CHECK_ALLOCATION_COMPARISION,
  payload: {},
});
export const clearReduxDataOnCheckAllocationComparisonDetailScr = () => ({
  type: actionTypes.REFRESH_DATA_CHECK_ALLOCATION_COMPARISON_DISPLAY,
  payload: {},
});
